export const initialStateCreateContractPipelineForm = {
  led_by: '',
  contract_category_name: '',
  estimated_bid_start_date: null,
  estimated_savings: ''
}
